<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        لیست نظرسنجی ها
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="success"
        class="mb-1 float-right"
        target="_blank"
        :href="exportExcel"
      >
        <feather-icon
          icon="FileTextIcon"
          class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        v-b-toggle.filter-box
        variant="outline-primary"
        class="mb-1"
      >
        <feather-icon
          icon="FilterIcon"
          class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
        id="filter-box"
        class="mb-2"
      >
        <b-card class="border mb-0">
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label>عنوان:</label>
                <b-form-input
                  v-model="search.title"
                  placeholder="نام را وارد نمایید."
                  type="text"
                  class="d-inline-block"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label=" تاریخ ایجاد"
                label-for="due-date"
              >
                <date-picker
                  v-model="search.createdDate"
                  type="date"
                  display-format="jDD jMMMM jYYYY"
                  format="YYYY-MM-DD"
                  clearable
                />

              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-overlay :show="rolesList.length === 0">
                <b-form-group>
                  <label for="role">
                    نقش
                  </label>
                  <v-select
                    v-model="search.roles"
                    multiple
                    dir="rtl"
                    label="slug"
                    :options="rolesList"
                    :reduce="role => role.id"
                    :close-on-select="false"
                  />
                </b-form-group>
              </b-overlay>

            </b-col>
            <b-col md="4">
              <b-overlay :show="permissionList.length === 0">
                <b-form-group>
                  <label for="permissions">
                    دسترسی
                  </label>
                  <v-select
                    v-model="search.permissions"
                    multiple
                    dir="rtl"
                    label="slug"
                    :options="permissionList"
                    :reduce="permission => permission.id"
                    :close-on-select="false"
                  />
                </b-form-group>
              </b-overlay>
            </b-col>
          </b-row>

          <hr>
          <div class="demo-inline-spacing">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
              @click="advanceSearch"
            >
              اعمال جستجو
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-secondary"
              @click="clearSearch"
            >
              حذف فیلترها
            </b-button>
          </div>
        </b-card>
      </b-collapse>

      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
            :fields="fields"
            :items="items"
            hover
            striped
          >
            <template #table-busy>
              <div class="text-center text-info my-2">
                <b-spinner class="align-middle" />
                <strong> درحال دریافت اطلاعات...</strong>
              </div>
            </template>

            <template #cell(roles)="data">
              <b-badge
                v-for="(role, index) in data.value"
                :key="index"
                variant="light-info"
                class="ml-1"
              >{{ role }}
              </b-badge>

            </template>
            <template #cell(permissions)="data">
              <b-badge
                v-for="(permission, index) in data.value"
                :key="index"
                variant="light-info"
                class="ml-1"
              >{{ permission }}
              </b-badge>

            </template>
            <template #cell(isActive)="data">
              <b-avatar
                  :id="`process-row-${data.item.id}`"
                  size="32"
                  :variant="data.value ? 'light-success': 'light-danger'"
              >
                <feather-icon
                    :icon="data.value ? 'CheckIcon': 'XIcon'"
                />
              </b-avatar>
            </template>

            <template #cell(action)="data">
              <b-dropdown
                text="عملیات"
                variant="outline-primary"
              >
                <b-dropdown-item :to="{name: 'Vote_Edit', params:{id: data.item.id}}">
                  <feather-icon
                    icon="EditIcon"
                    class="text-warning"
                  />
                  ویرایش
                </b-dropdown-item>
              </b-dropdown>
            </template>

          </b-table>
          <b-pagination
            v-model="currentPage"
            class="mt-2"
            :total-rows="totalRows"
            :per-page="perPage"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BSpinner,
  BBadge,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BPagination, BFormInput, BCollapse, BFormGroup, BButton, VBToggle, BAvatar,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { doubleRaf, queryString } from '@/libs/utils'
import { computed } from '@vue/composition-api'

export default {
  name: 'VoteList',
  components: {
    BAvatar,
    BButton,
    VSelect,
    BFormGroup,
    BCollapse,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BPagination,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'شناسه',
        },
        {
          key: 'title',
          label: 'عنوان',
        },
        {
          key: 'link',
          label: 'لینک',
        },
        {
          key: 'roles',
          label: 'نقش',
        },
        {
          key: 'permissions',
          label: 'دسترسی ها',
        },
        {
          key: 'createdDate',
          label: 'تاریخ ساخت',
        },
        {
          key: 'creator.name',
          label: 'سازنده',
        },
        {
          key: 'isActive',
          label: 'وضعیت',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      onProgress: true,
      search: {},
      rolesList: [],
      permissionList: [],
      receiversList: [],
      getReceivers: false,
      onExportProgress: false,
    }
  },

  mounted() {
    this.getVoteList()
    this.getPermissions()
    this.getRoles()
    this.setSearchData()
  },

  computed: {
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}votes?export-excel=1&${query}`
    }
  },
  methods: {
    getVoteList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true

      this.$http.get('votes', {
        params: {
          ...currentQuery,
          ...this.search,
          page: this.currentPage,
        },
      })
        .then(({ data }) => {
          if (data.status) {
            this.items = data.votes
            this.currentPage = data.meta.current_page
            this.totalRows = data.meta.total
            this.perPage = data.meta.per_page
          } else {
            this.$bvToast.toast(data.message ?? 'در دریافت لیست کاربران خطایی رخ داده', {
              title: 'حطا',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
        .then(() => {
          this.getVoteList()
        })
        .catch(() => {
        })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
        .then(() => {
          this.getVoteList()
        })
        .catch(() => {
        })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    getRoles() {
      this.$http.get('user/roles?paginate=false')
        .then(({ data }) => {
          if (data.status) {
            this.rolesList = data.roles
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست نقش ها با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },
    getPermissions() {
      this.$http.get('user/permissions?paginate=false')
        .then(({ data }) => {
          this.permissionList = data.permissions
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query))
      })
    },
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'My_Votes',
          query: { page: this.currentPage },
        })
        this.items = []
        this.getVoteList()
      }
    },
  },
}
</script>

<style>

</style>
